import React from 'react';

const GameSidebar = ({
  players,
  currentTurn,
  gameStatus,
  playerColor,
  onResign,
  boardSize,
  winCondition
}) => {
  const handleResign = () => {
    if (window.confirm('Are you sure you want to resign?')) {
      onResign();
    }
  };

  const getPlayerByColor = (color) => {
    return Object.values(players).find(player => player.color === color);
  };

  const formatGameStatus = () => {
    if (gameStatus.isGameOver) {
      if (gameStatus.winner) {
        const winnerPlayer = getPlayerByColor(gameStatus.winner);
        return `${winnerPlayer?.name || gameStatus.winner} wins!`;
      } else {
        return 'Draw!';
      }
    }
    
    if (currentTurn === playerColor) {
      return 'Your turn';
    } else {
      const currentPlayer = getPlayerByColor(currentTurn);
      return `${currentPlayer?.name || currentTurn}'s turn`;
    }
  };

  const xPlayer = getPlayerByColor('X');
  const oPlayer = getPlayerByColor('O');

  return (
    <div className="game-sidebar">
      <div className="game-info">
        <h3>Game Info</h3>
        <div className="info-item">
          <span className="label">Board:</span>
          <span className="value">{boardSize}×{boardSize}</span>
        </div>
        <div className="info-item">
          <span className="label">Win condition:</span>
          <span className="value">{winCondition} in a row</span>
        </div>
        <div className="info-item">
          <span className="label">Your color:</span>
          <span className="value">
            <span className={`piece piece-${playerColor?.toLowerCase()}`}>
              {playerColor}
            </span>
          </span>
        </div>
      </div>

      <div className="players-info">
        <h3>Players</h3>
        
        <div className={`player-info ${currentTurn === 'X' ? 'active' : ''}`}>
          <div className="player-header">
            <span className="piece piece-x">X</span>
            <span className="player-name">
              {xPlayer ? xPlayer.name : 'Waiting...'}
            </span>
          </div>
          {xPlayer && playerColor === 'X' && (
            <span className="you-indicator">(You)</span>
          )}
        </div>

        <div className={`player-info ${currentTurn === 'O' ? 'active' : ''}`}>
          <div className="player-header">
            <span className="piece piece-o">O</span>
            <span className="player-name">
              {oPlayer ? oPlayer.name : 'Waiting...'}
            </span>
          </div>
          {oPlayer && playerColor === 'O' && (
            <span className="you-indicator">(You)</span>
          )}
        </div>
      </div>

      <div className="game-status">
        <h3>Status</h3>
        <div className={`status-text ${gameStatus.isGameOver ? 'game-over' : ''}`}>
          {formatGameStatus()}
        </div>
        
        {gameStatus.isGameOver && gameStatus.reason && (
          <div className="game-end-reason">
            Reason: {gameStatus.reason}
          </div>
        )}
      </div>

      <div className="game-controls">
        {!gameStatus.isGameOver && playerColor && (
          <button
            className="danger-button"
            onClick={handleResign}
          >
            Resign
          </button>
        )}
        
        {gameStatus.isGameOver && (
          <div className="game-over-info">
            <p>Game finished!</p>
            {gameStatus.winningLine && (
              <p>Winning line: {gameStatus.winningLine.length} pieces</p>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default GameSidebar;
